import { CLEAR_ONGOING_CALL } from "../../CONSTANTS";

export default function clearOngoingCall() {
  return {
    type: CLEAR_ONGOING_CALL,
  };
}



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/actions/calls/clearOngoingCall.js